// 订单相关
// @ts-check
export default {
  'order.dingding.list.title': 'Contract List',
  'order.dingding.column.contractDate': 'Contract Date',
  'order.dingding.column.contractDate_begin': 'Start Date',
  'order.dingding.column.contractDate_end': 'End Date',
  'order.dingding.column.contractDate.placeholder': 'Please select contract date',
  'order.dingding.column.contractNo': 'Contract No.',
  'order.dingding.column.contractNo.placeholder': 'Please enter contract number',
  'order.dingding.column.sale': 'Sales',
  'order.dingding.column.sale.placeholder': 'Please select sales',
  'order.dingding.column.manager': 'PM',
  'order.dingding.column.manager.placeholder': 'Please select project manager',
  'order.dingding.button.update': 'Update from DingDing',
  'order.dingding.column.orderNo': 'Order No.',
  'order.dingding.column.amount': 'Amount',
  'order.collect.modal.title': 'My Favorites',
  'order.collect.select.modal.title': 'Select favorites',
  'order.collect.column.name': 'Favorite Name',
  'order.collect.column.input.name': 'Please enter favorite name',
  'order.collect.column.stepName': 'Task Name',
  'order.collect.column.input.stepName': 'Please enter task name',
  'order.collect.column.stepName.placeholder': 'Please enter task name',
  'order.collect.column.noSpace': 'Favorite name/task name cannot consist of only spaces, and the first character cannot be a space',
  'order.collect.column.userName': 'Responsible Person',
  'order.collect.column.input.userName': 'Please select responsible person',
  'order.collect.column.type': 'Type',
  'order.collect.column.cat': 'Category',
  'order.collect.button.add': 'Add Favorite',
  'order.collect.button.nodeSet': 'Configure Process',
  'order.collect.column.sequence': 'Sort',
  'order.dingding.column.update': 'Update from DingDing',
  'order.frontConfig.modal.title': 'Pre-task Configuration',
  'order.service.select': 'Select task',
  'order.collect.type1': 'Service',
  'order.collect.type2': 'Custom',
  'order.collect.type3': 'Fixed',
  'order.collect.search.inputHolder': 'Please enter favorite name/task name/responsible person',
  'order.collect.edit.tip': 'Please save the current edited content first',


  "order.list.orderDate": "Order Date",
  "order.list.startDate": "Start Date",
  "order.list.endDate": "End Date",
  "order.list.contractDate": "Contract Date",
  "order.list.customerName": "Customer Name",
  "order.list.sales": "Sales",
  "order.list.projectManager": "PM",
  "order.list.projectManagerAll": "Project Manager",
  "order.list.estimatedCompletionDate": "Estimated Completion Date",
  "order.list.estimatedCompletionDateA": "ECD",
  "order.list.selectDate": "Select date",
  "order.list.orderStatus": "Order Status",
  "order.list.status": "Status",
  "order.list.selectStatus": "Select status",
  "order.list.currency": "Currency",
  "order.list.selectCurrency": "Select currency",
  "order.list.orderType": "Order Type",
  "order.list.type": "Type",
  "order.list.selectOrderType": "Select order type",
  "order.list.orderProcessingStatus": "Process Status",
  "order.list.processingStatus": "Processing Status",
  "order.list.selectProcessingStatus": "Select process status",
  "order.list.processor": "Processor",
  "order.list.cancelOrder": "Cancel Order",
  "order.list.show": "Show",
  "order.list.hide": "Hide",
  "order.list.search": "Search",
  "order.list.reset": "Reset",
  "order.list.addOrder": "Add Order",
  "order.list.view": "View",
  "order.list.edit": "Edit",
  "order.list.process": "Process",
  "order.list.delete": "Delete",
  "order.list.more": "More",
  "order.list.assignTask": "AssignTask",
  "order.list.receivePayment": "Receive Payment",
  "order.list.makePayment": "Payment",
  "order.list.issueInvoice": "Issue Invoice",
  "order.list.closeOrder": "Close",
  "order.list.nullify": "Void",
  "order.list.copy": "Copy",
  "order.list.operator": "Operator",
  "order.list.operation": "Operation",
  "order.list.amount": "Amount",
  "order.list.deleteTips": "Are you sure you want to delete this item?",
  "order.list.activeTips": "Are you sure you want to perform this action?",
  "order.list.basicInfo": "Basic Information",
  "order.list.orderNumber": "Order No.",
  "order.list.enterOrderNumber": "Enter Order No.",
  "order.list.contractNumber": "Contract No.",
  "order.list.enterContractNumber": "Enter contract number",
  "order.list.contractSigningDate": "Contract Signing Date",
  "order.list.selectContractSigningDate": "Select contract signing date",
  "order.list.customerNumber": "Customer Number",
  "order.list.enterCustomerNumber": "Enter customer number",
  "order.list.orderAmount": "Order Amount",
  "order.list.enterOrderAmount": "Enter order amount",
  "order.list.shSales": "Shanhai Map Sales",
  "order.hint": "Please select the filter item you want to query",
  "order.list.contractTaxRate": "Contract Tax Rate",
  "order.list.enterContractTaxRate": "Enter contract tax rate",
  "order.list.selectStartDate": "Select start date",
  "order.list.estimatedCompletion": "Estimated Delivery Date",
  "order.list.selectEstimatedCompletionDate": "Select estimated completion date",
  "order.list.exchangeRate": "Exchange Rate",
  "order.list.contractScanCopy": "Double-Signature Contract",
  "order.list.serviceList": "Service List",
  "order.list.add": "Add",
  "order.list.remark": "Remark",
  "order.list.cancel": "Cancel",
  "order.list.save": "Save",
  "order.list.submit": "Submit",
  "order.list.total": "Total",
  "order.list.totalReceiptAmount": "Total Receipt Amount",
  "order.list.totalServiceFee": "Total Service Fee",
  "order.list.confirmCancellation": "Are you sure to cancel?",
  "order.list.serialNumber": "Serial Number",
  "order.list.receiptName": "Receipt Name",
  "order.list.productName": "Product Name",
  "order.list.receiptAccount": "Receipt Account",
  "order.list.receiptAmount": "Receipt Amount",
  "order.list.serviceFee": "Service Fee",
  "order.list.receiptDate": "Receipt Date",
  "order.list.normal": "Normal",
  "order.list.cancelled": "Cancelled",
  "order.list.description": "Description",
  "order.list.operationTime": "Operation Time",
  "order.list.processingFlow": "Processing Flow",
  "order.list.fullyImplemented": "Fully Implemented",
  "order.list.inProgress": "In Progress",
  "order.list.completed": "Completed",
  "order.list.notProcessed": "Not Processed",
  "order.list.file": "File",
  "order.list.email": "Email",
  "order.list.phoneNumber": "Phone Number",
  "order.list.invoiceInformation": "Invoice Information",
  "order.list.receiptInformation": "Receipt Information",
  "order.list.paymentInformation": "Payment Information",
  "order.list.customerNotification": "Customer Notification",
  "order.list.step": "Step",
  "order.list.workflowName": "Workflow Name",
  "order.list.precedingTask": "Pre-task",
  "order.list.unitPrice": "Unit Price",
  "order.list.discount": "Discount",
  "order.list.totalIncludingTax": "Total Incl. Tax",
  "order.list.quantity": "Quantity",
  "order.list.responsiblePerson": "Principal",
  "order.list.duration": "Duration",
  "order.list.estimatedCompletionTime": "Arrival Estimated Date",
  "order.list.node": "Node",
  "order.list.nodeName": "Node Name",
  "order.list.durationWorkingDays": "Duration (Working Days)",
  "order.list.maxdurationWorkingDays": "Max Duration (Working Days)",
  "order.list.processingTime": "Processing Time",
  "order.list.progressDescription": "Progress Description",
  "order.list.company": "Company",
  "order.list.registeredEmail": "Registered Email",
  "order.list.inputRemark": "Input Remark",
  "order.list.paymentTime": "Payment Time",
  "order.list.invoiceTime": "Invoice Time",
  "order.list.taxRate": "Tax Rate%",
  "order.list.voided": "Voided",
  "order.list.selectCustomer": "Select customer",
  "order.list.selectSales": "Select sales representative",
  "order.list.selectManager": "Select manager",
  "order.list.uploadContract": "Please Upload Double-Signature Contract",
  "order.list.success": "Operation Successful",
  "order.list.emptyServiceList": "Order Service List cannot be empty",
  "order.list.inconsistentAmount": "Service total amount is inconsistent with the order amount, please check!",
  "order.list.none": "None",
  "order.list.details": "Details",
  "order.list.product": "Product",
  "order.list.invoiceTotalAmount": "Invoice Total Amount",
  "order.list.invoiceNumber": "Invoice Number",
  "order.list.paymentProgress": "Payment Progress%",
  "order.list.paymentName": "Payment Name",
  "order.list.paymentAccount": "Payment Account",
  "order.list.exchangeAmount": "Exchange Amount",
  "order.list.taxes": "Taxes",
  "order.list.excludingTax": "Amount (Excluding Tax)",
  "order.list.createWeeklyReport": "Create Weekly Report",
  "order.list.confirmOperation": "Are you sure you want to perform this operation?",
  "order.list.complete": "Complete",
  "order.list.handleNodeFirst": "Please handle the node first",
  "order.list.estimatedTime": "Estimated Time",
  "order.list.reminderDate": "Reminder Date",
  "order.list.reminderLevel": "Reminder Level",
  "order.list.selectReminderLevel": "Select reminder level",
  "order.list.enterServiceName": "Enter Service Name",
  "order.list.selectServiceName": "Select Service Name",
  "order.list.processStatus": "Process Status",
  "order.list.export": "Export",
  "order.list.reminderTime": "Reminder Time",
  "order.list.serviceProcessName": "Service Process Name",
  "order.list.reminderContent": "Reminder Content",
  "order.list.serviceEstimatedCompletionTime": "Service Estimated Delivery Date",

  "order.list.uncertain": "Uncertain",
  "order.list.invoiceCollection": "Invoice Collection",
  "order.list.saveCurrentProcessFirst": "Please save the current added process first",
  "order.list.completeProcessInformation": "Please complete the process information",
  "order.list.fillInProcessorInformation": "Please fill in processor information",
  "order.list.selectProcessEstimatedTime": "Please select the estimated time for the process",
  "order.list.selectProcessAttribute": "Please select the process attribute",
  "order.list.saveSuccess": "Save successful",
  "order.list.notPass": "Not pass",
  "order.list.pass": "Pass",
  "order.list.selectOrderProcessChecker": "Select order process checker",
  "order.list.confirm": "Confirm",
  "order.list.checker": "Checker",
  "order.list.secondCheckUser": "Checker",
  "order.list.checkOpinion": "Check opinion",
  "order.list.enterCheckOpinion": "Please enter check opinion",
  "order.list.selectChecker": "Please select checker",
  "order.list.saveCurrentTaskFirst": "Please save the current added task first",
  "order.list.selectNode": "Please select node",
  "order.list.contractRegistrationDate": "Contract registration date",
  "order.list.serviceName": "Service Name",
  "order.list.documentType": "Document Type",
  "order.list.selectDocumentType": "Please select document type",
  "order.list.uploadFile": "Upload file",
  "order.list.download": "Download",
  "order.list.confirmDelete": "Are you sure you want to delete?",
  "order.list.confirmDelete.all": "Are you sure you want to delete all?",
  "order.list.documentDescription": "Document description",
  "order.list.uploadTime": "Upload time",
  "order.list.uploadSuccess": "Upload successful",

  "order.list.process2": "Process",
  "order.list.processName": "Process Name",
  "order.list.enterProcessName": "Enter process name",
  "order.list.workingDays": "Duration (Working Days)",
  "order.list.enterWorkingDays": "Enter duration",
  "order.list.processingRole": "Processing Role",
  "order.list.selectProcessingRole": "Select processing role",
  "order.list.processor2": "Processor",
  "order.list.processDescription": "Process Description",
  "order.list.customerVisibility": "Customer Visibility",
  "order.list.private": "Private",
  "order.list.public": "Public",
  "order.list.customerPrompt": "Customer Prompt",
  "order.list.promptDescription": "Prompt Description",
  "order.list.selectAtLeastOneProcessor": "Please select at least one processor",
  "order.list.completeProcessorInformation": "Please complete processor information",
  "order.list.invalidEmail": "Invalid Email",
  "order.list.enterProcess": "Enter process",
  "order.list.selectCustomerVisibility": "Select customer visibility",
  "order.list.enterWorkingDaysNumeric": "Enter duration (numeric)",
  "order.list.enterProcessDescription": "Enter process description",
  "order.list.notInSelectedProcessingRole": "Not in selected processing role",
  "order.list.selectCompanyOrCustomer": "Select company/customer",
  "order.list.selectCompany": "Select company",
  "order.list.enterCompanyNameCustomerNameEmail": "Enter company name, customer name, registration email",
  "order.list.favorite": "Favorite",
  "order.list.enterFavoriteName": "Enter favorite name",
  "order.list.taskName": "Task Name",
  "order.list.addProcess": "Add Process",
  "order.list.pushSort": "Sort",
  "order.list.fixedNode": "Fixed Node",
  "order.list.custom": "Custom",
  "order.list.role": "Role",
  "order.list.attribute": "Attribute",
  "order.list.completeAddProcessName": "Please complete adding process name",
  "order.list.saveOrCancelCustomProcessFirst": "Please save or cancel custom process first",
  "order.list.selectTime": "Select time",
  "order.list.selectAttribute": "Select attribute",
  "order.list.configureSubProcess": "Configure sub-process",
  "order.list.processingProcess": "Processing process",
  "order.list.processingTask": "Processing task",
  "order.list.myFavoriteTasks": "My favorite tasks",
  "order.list.addTask": "Add task",
  "order.list.task": "Task",
  "order.list.preTask": "Pre-task",
  "order.list.genericTaskFillSuccess": "Generic task filled successfully",
  "order.list.genericTaskNotConfigured": "The generic task is not configured with a process, please complete the process information",
  "order.list.selectSameTypeFavoriteEntry": "Please select the same type of favorite entry for filling",
  "order.list.favoriteTaskFillSuccess": "Favorite task filled successfully",
  "order.list.favoriteNotConfigured": "The favorite is not configured with a process, please complete the process information",
  "order.list.enterTaskName": "Enter task name",
  "order.list.taskNameNotEmptySpaces": "Task name cannot be pure spaces, and the first character cannot be a space",
  "order.list.selectResponsiblePersonOr": "Select responsible person",
  "order.list.or": "or",
  "order.list.selectPreProcessingTask": "Select pre-processing task, multiple selections allowed",
  "order.list.checkStatus": "Check status",
  "order.list.notChecked": "Not checked",
  "order.list.enter": "Enter",
  "order.list.miaos": "Description",
  "order.list.qtxscmc": "Please fill in the favorite name",
  "order.list.qsrzdylcm": "Enter custom process name",
  "order.list.tyrw": "Generic task",
  "order.list.cklc": "Check process",
  "order.list.xzzbht": "Select weekly report contract",
  "order.list.zbjl": "Weekly report record",
  "order.list.kh": "Customer",
  "order.list.qxzht": "Please select a contract",
  "order.list.qxztykhcjzb": "Please select the same customer to create a weekly report",
  "order.list.tjdy": "Add Subscription",
  "order.list.cjr": "Creator",
  "order.list.cjrq": "Creation Date",
  "order.list.qxzkpskjd": "Please select invoicing and receipt node",
  "order.list.taskNumber": "Task Number",
  "order.list.enterProcessNumber": "Enter process number",
  "order.list.taskStatus": "Task Status",
  "order.list.disabled": "Disabled",
  "order.list.enabled": "Enabled",
  "order.list.approvalTemplateNumber": "Approval Template No.",
  "order.list.serviceProcess": "Service Process",
  "order.list.Ordercreationdate": "Order Creation Date",
  "order.list.Contractregistrationdate": "Contract Registration Date",
  "order.list.contractamount": "Contract Amount",
  "order.list.Handlingpersonnelsetup": "Handling Personnel Setup",

  "order.list.basicInformation": "Basic Information",
  "order.list.assignOrder": "Assign Order",
  "order.list.contractAmountIncludingTax": "Contract Amount (Incl. Tax)",
  "order.list.pleaseSelect": "Please Select",
  "order.list.contractBelongingCountry": "Contract Belonging Country",
  "order.list.orderOnCountry": "Product Country",

  "order.list.contractSigningCountry": "Please Select Contract Signing Country",
  "order.list.contractVATRate": "Contract VAT Rate",
  "order.list.PlesecontractVATRate": "Please enter contract VAT rate",
  "order.list.customerChineseCompanyName": "Customer Chinese Company Name",
  "order.list.customerCode": "Customer Code",
  "order.list.contractScannedCopy": "Contract Scanned Copy",
  "order.list.serviceInformation": "Service Information",
  "order.list.nextStep": "Next Step",
  "order.list.serviceNumber": "Service Number",
  "order.list.servicePrice": "Service Price",
  "order.list.serviceCategory": "Service Category",
  "order.list.FPprojectManager": "Assign PM",
  "order.list.contractInfo": "Contract Information",
  "order.list.countryRegion": "Country/Region",
  "order.list.qsrbllcmc": "Enter Process Name",
  "order.list.qsrblfzr": "Enter Responsible Person",
  "order.list.qsryjsj": "Enter Expected Time",
  "order.list.qsrzdyrw": "Enter Custom Task",
  "order.list.fwm": "Service Name",
  "order.list.wdmc": "Document Name",
  "order.list.rwmc": "Task Name",
  "order.list.inputCountry": "Enter Country",
  "order.list.accountsReceivable": "Accounts Receivable",
  "order.list.pendingPayment": "Pending Payment",
  "order.list.performance": "Performance",
  "order.list.brand": "Brand",
  "order.list.all": "All",
  "order.list.hide2": "Hide",
  "order.list.wgj": "Not Followed",
  "order.list.ygj": "Followed",
  "order.list.enterCollectionName": "Enter Collection Name",
  "order.list.collectionVoucher": "Collection Voucher",
  "order.list.collectionAccount": "Collection Account",
  "order.list.selectCollectionAccount": "Select Collection Account",
  "order.list.ticketNumber": "Ticket Number",
  "order.list.selectTicketNumber": "Select Ticket Number",
  "order.list.enterTaxRate": "Enter Tax Rate",
  "order.list.apportionService": "Apportion Service",
  "order.list.selectService": "Select Service",
  "order.list.apportionInvoiceAmount": "Apportion Invoice Amount",
  "order.list.canApportion": "Can Apportion",
  "order.list.accountsReceivableAmount": "Accounts Receivable Amount",
  "order.list.actualReceivedAmount": "Actual Received Amount",
  "order.list.collectionTime": "Collection Time",
  "order.list.selectCollectionTime": "Select Collection Time",
  "order.list.enterPaymentName": "Enter Payment Name",
  "order.list.selectCollectionVoucher": "Select Collection Voucher",
  "order.list.selectAccount": "Select Account",
  "order.list.enterActualReceivedAmount": "Enter Actual Received Amount",
  "order.list.sameServiceCannotApportionMultipleTimes": "Same service cannot be apportioned multiple times",
  "order.list.actualReceivedAmountCannotExceedInvoiceAmount": "Actual Received Amount cannot exceed Invoice Amount",

  "order.list.skjl": "Collection Records",
  "order.list.qsrskf": "Enter Payee",
  "order.list.qxzfksj": "Select Payment Time",
  "order.list.isShared": "Is Shared",
  "order.list.notShared": "Not Shared",
  "order.list.shared": "Shared",
  "order.list.enterDocumentName": "Enter document name",
  "order.list.enterDocumentSource": "Enter document source",
  "order.list.invoiceRecord": "Invoice record",
  "order.list.invoiceType": "Invoice type",
  "order.list.enterInvoiceNumber": "Enter invoice number",
  "order.list.selectInvoiceTime": "Select invoice time",
  "order.list.selectInvoiceType": "Select invoice type",
  "order.list.paymentRecord": "Payment record",
  "order.list.payee": "Payee",
  "order.list.paymentVoucher": "Payment voucher",
  "order.list.refreshExchangeRate": "Refresh exchange rate",
  "order.list.enterPaymentAmount": "Enter payment amount",
  "order.list.enterExchangeRate": "Enter exchange rate",
  "order.list.selectPaymentVoucher": "Select payment voucher",
  "order.list.productCategory": "Product category",
  "order.list.selectProductCategory": "Select product category",
  "order.list.specification": "Specification",
  "order.list.originalUnitPrice": "Original unit price",
  "order.list.unitReceivableAmount": "Unit receivable amount (Excl. Tax)",
  "order.list.eachDiscount": "Each discount",
  "order.list.taxInclusiveTotalPrice": "Tax-inclusive total price",
  "order.list.selectProduct": "Select product",
  "order.list.enterQuantity": "Enter quantity",
  "order.list.enterOriginalUnitPrice": "Enter original unit price",
  "order.list.enterReceivableAmount": "Enter receivable amount",
  "order.list.enterEachDiscount": "Enter each discount",
  "order.list.noConfiguredNodeForThisService": "No configured node for this service, adding rejected",
  "order.list.selectSpecification": "Select specification",
  "order.list.enterCompanyName": "Company name",
  "order.list.enterCompanyName2": "Enter Company Name",
  "order.list.syncInProgress": "Sync in progress",
  "order.list.sync": "Sync",
  "order.list.enterCustomerName": "Enter Customer Name",
  "order.list.chinaCompanyName": "Company name",
  "order.list.overseasCompanyName": "Overseas company name",
  "order.list.country": "Country",
  "order.list.syncSuccess": "Sync success",
  "order.list.fileDownload": "File download",
  "order.list.enterNodeName": "Enter node name",
  "order.list.enterNodeDescription": "Enter node description",
  "order.list.processingTimeInDays": "Processing time",
  "order.list.enterProcessingTime": "Enter processing time",
  "order.list.processingDate": "Processing date",
  "order.list.selectProcessingDate": "Select processing date",
  "order.list.enterProgressDescription": "Enter progress description",
  "order.list.sendNotification": "Send notification",
  "order.list.send": "Send",
  "order.list.enterNode": "Enter Node",
  "order.list.enterWorkingTime": "Enter Working Time",
  "order.list.selectProcessingTime": "Select Processing Time",
  "order.list.pushNotificationInformation": "Push Notification Information",
  "order.list.channel": "Channel",
  "order.list.templateNotSelected": "Template not selected. Please select a template before previewing.",
  "order.list.preview": "Preview",
  "order.list.enterTemplateName": "Enter Template Name",
  "order.list.selectParameters": "Select Parameters",
  "order.list.options": "Options",
  "order.list.miniProgramNotificationContent": "Notification Content",
  "order.list.completeParameters": "Please complete parameters",
  "order.list.enterCustomVariableValue": "Enter Custom Variable Value",
  "order.list.totalAmount": "Total Amount",
  "order.list.valueAddedTax": "Value Added Tax",
  "order.list.totalInclusiveAmount": "Total Inclusive Amount",
  "order.list.productUnitPrice": "Product Unit Price",
  "order.list.unitDiscount": "Unit Discount",
  "order.list.enterNodeName2": "Enter Node Name",
  "order.list.enterNodeDescription2": "Enter Node Description",
  "order.list.parameter": "Parameter",
  "order.list.xzkh": "Select Customer",
  "order.list.billingAmountWithTax": "Billing Amount (with Tax)",
  "order.list.billingAmount": "Billing Amount",
  "order.list.receivableAmount": "Receivable Amount",
  "order.list.receivableBillingAmount": "Receivable Billing Amount",
  "order.list.unreceivedAmount": "Unreceived Amount",
  "order.list.receivedAmount": "Received Amount",
  "order.list.fileDownloadFailed": "File Download Failed",
  "order.list.hksc": "Repayment Duration",
  "order.list.yhkje": "Received Amount",
  "order.list.hkbl": "Repayment Ratio",
  "order.list.contractManager": "Contract Manager",
  "order.list.checked": "Checked",
  "order.list.selectedServices": "Selected Services",
  "order.list.selectedCountry": "Select Country",
  "order.list.selectedServicesRequired": "Please select at least one service",
  "order.list.orderCountry": "Order Country",
  "order.list.paymentMethod": "Payment Method",
  "order.list.paymentMethodRequired": "Please select a payment method",
  "order.list.createOrder": "Create Order",
  "order.list.orderCreated": "Order Created",
  "order.list.processing": "Processing",
  "order.list.closed": "Closed",
  "order.list.PleaseAssignOrder": "Please assign the order",
  "order.list.PleaseAssigncontractlevel": "Please select the contract level",
  "order.list.Contractlevel": "Contract Level",
  "order.list.orderCreatedSuccessfully": "Order created successfully",
  "order.list.createSuccess": "Creation successful. Please continue to add new orders if needed",
  "order.list.backToContractList": "Back to contract list",
  "order.list.Continueadd": "Continue to add",
  "order.list.actualCompletionDate": "Actual Completion Date",
  "order.list.actualCompletionTime": "Actual Completion Time",
  "order.list.fileManagement": "File management",
  "order.list.startTime": "Start Time",
  "order.list.completionTime": "Completion Time",
  "order.list.noPreTask": "No prerequisite tasks",
  "order.list.atLeastOnePrerequisiteTask": "Please select at least one prerequisite task",
  "order.list.prerequisiteTask": "Select prerequisite task",
  "order.list.notificationcustomer": "Notify customer",
  "order.list.reminder": "Remind Customer",
  "order.list.promptDesc": "Remind Content",
  "order.list.on": "Yes",
  "order.list.off": "No",
  "order.list.termination": "Terminate",
  "order.list.instruction": "Processing instructions",
  "order.list.instruction2": "Please enter processing instructions",
  "order.list.PM.rate": "Project Manager Rating",
  "order.list.PM.completed": "Completed",
  "order.list.PM.uncompleted": "Unfinished",
  "order.list.PM.evalItems": "Work items",
  "order.list.PM.score": "Score",
  "order.list.PM.scoreDescribe": "Scoring Instructions",
  "order.list.PM.scoreDescribe.placeholder": "Please rate.",
  "order.list.PM.scoreDescribe.noedit": "The score cannot be modified.",
  "order.list.PM.scoreDescribe.completed": "Please complete the project manager's scoring",
  "order.list.PM.scoreDescribe.default": "The level does not require a project kick-off meeting and automatically defaults to one point.",
  "order.list.PM.scoreDescribe.default2": "The project kick-off meeting was not uploaded, and the score defaults to zero.",
  "order.list.PM.score.nosave": "The score modification was not saved! Click 'OK' to confirm that your changes will not be retained. Are you sure to continue?",
  "order.list.node.complete.tip": "Are you sure the current node has been completed?",
  "order.list.node.allcomplete.tip": "Are you sure the service has been completed?",
  "order.list.PM.satisfied": "Excellent",
  "order.list.PM.average": "Qualified",
  "order.list.PM.notSatisfied": "Developing",
  "order.list.PM.totalScore": "The total score is ",
  "order.list.PM.getScore": " and the score is",
  "order.list.PM.points": " points",
  "order.list.wait": "Wait",
  "order.list.plannedDuration": "Planned duration (working days)",
  "order.list.need": "Need",
  "order.list.NOneed": "Not needed",
  "order.list.processingRecord": "Processing record",
  "order.list.expected_restart_time": "Expected restart time",
  "order.list.returned": "Returned",
  "order.list.suspended": "Suspended",
  "order.list.myVariableKey": "Restart task",
  "order.list.returnExplanation": "Return explanation",
  "order.list.PleasereturnExplanation": "Please enter return explanation",
  "order.list.onlyProjectManagerCanSuspend": "Only the project manager of this order can suspend",
  "order.list.confirmExecute": "Are you sure to execute this operation?",
  "order.list.expectedRestartDate": "Expected restart date",
  "order.list.selectExpectedRestartDate": "Please select expected restart date",
  "order.list.suspendExplanation": "Suspend explanation",
  "order.list.enterSuspendExplanation": "Please enter suspend explanation",
  "order.list.restart": "Restart",
  "order.list.start": "Start",
  "order.list.restartSuccess": "Restart successful",
  "order.list.returnSuccess": "Return successful",
  "order.list.suspendSuccess": "Suspend successful",
  "order.list.contractRegistrationService": "Contract registration service",
  "order.list.selectContractRegistrationService": "Please select contract registration service",
  "order.list.serviceQuantity": "Service quantity available",
  "order.list.enterTaskNameCN": "Enter task name (Chinese)",
  "order.list.enterTaskNameLocal": "Enter task name (Local)",
  "order.list.taskNameLocal": "Task name (Local)",
  "order.list.taskNameCN": "Task name (Chinese)",
  "order.list.enterName": "Enter Name",
  "order.list.noNodeConfigured": "No nodes configured for this service, adding denied",
  "order.list.serviceQuantityExceeded": "Service quantity exceeded",
  "order.list.serviceQuantityCannotBeZero": "Service quantity cannot be 0",
  "order.list.handlerInformation": "Handler Information",
  "order.list.projectManagerAcceptanceHandlerLimit": "PM acceptance handler limited to 1 person",
  "order.list.salesInvoiceHandlerLimit": "Sales invoice handler limited to 1 person",
  "order.list.pleaseAdd": "Please add",
  "order.list.taskFlow": "Task Flow",
  "order.list.restoreDefault": "Restore Default/Update Task Nodes",
  "order.list.sort": "Sort",
  "order.list.viewTask": "ViewTask",
  "order.list.foxmessage": "Check Message",
  "order.list.retask": "Re-decompose Task",
  "order.list.confirmtask": "Confirm Task",
  "order.list.backed": "Returned",

  "order.list.khbmyw": "Incorrect customer number",
  "order.list.gldd": "Associated order",
  "order.list.fwdh": "Service unit price",
  "order.list.wfzjbhs": "Total service price (Excl. Tax)",

  "order.evaluate.evaluationDate": "Evaluation Date",
  "order.evaluate.evaluationLevel": "Evaluation Level",
  "order.evaluate.selectEvaluationLevel": "Select Evaluation Level",
  "order.evaluate.followUpStatus": "Follow-up Status",
  "order.evaluate.selectFollowUpStatus": "Select Follow-up Status",
  "order.evaluate.myParticipation": "My Participation",
  "order.evaluate.hideEmptyReviews": "Hide Empty Reviews",
  "order.evaluate.followUp": "Follow-up",
  "order.evaluate.negativeReview": "Negative Review",
  "order.evaluate.neutralReview": "Neutral Review",
  "order.evaluate.positiveReview": "Positive Review",
  "order.evaluate.evaluationContent": "Evaluation Content",

  "order.evaluate.Nocontractmanagerassigned": "Contract manager not assigned",
  "order.evaluate.Assignthisprojectmanager": "Assign this project manager as the contract manager",
  "order.evaluate.checkout1": "Contract service and international service cannot be selected simultaneously",
  "order.evaluate.checkout2": "Cannot select contract country when choosing international service",
  "order.evaluate.checkout3": "The selected country and service do not match",
  "order.evaluate.selecttheassignedcontract": "Please select the assigned contract first",

  "order.evaluate.task": "Re-decomposition: You can redistribute order tasks. At this time, other associated orders cannot select tasks under this order as predecessor tasks.",
  "order.evaluate.task2": "After task confirmation, deletion or addition of tasks is not allowed. At this point, the order tasks can be used as predecessor tasks for other associated orders.",
  "order.evaluate.pleasename": "Please enter username",
  "order.evaluate.ClickDragtoUpload": "Click/Drag to Upload",
  "order.list.Checking": "Checking",
  "order.evaluate.orderCount": "Order Count",
  "order.evaluate.productCount": "Product Count",
  "order.list.customerNameSX": "Customer",
  "order.list.CM": "CM",
  "order.list.CMAll": "Contract Manager",
  "order.list.tbcrmsj": "Sync CRM data",
  "order.list.tbcrmsjTips": "Click to start updating the latest data in CRM; the update will be completed in 2 minutes.",
  "order.list.xzyh": "USER",
  "order.list.unitDealPrice": "Unit Deal Price",
  "order.list.fixAPrice": "Fixed Pricing",
  "order.list.includingTax": "Amount (Including Tax)",
  "order.list.tips1": "{param} Description",
  "order.list.tips2": "Enter {param} Description",
  "order.list.voidDescription": "Void Description",
  "order.list.closingDescription": "Closing Description",

  "order.workHandover": "Work Handover",
  "order.handoverHistory": "Handover History",
  "order.transferContractOwner": "Transfer Contract Owner",
  "order.transferProjectManager": "Transfer PM",
  "order.transferHandler": "Transfer Handler",
  "order.transferChineseSupport": "Transfer ChineseSupport",
  "order.transferChineset": "ChineseSupport Handover",
  "order.confirmContractOwnerAsHandler": "The current handler is the contract owner, confirming will also modify the contract owner",
  "order.operationDate": "Operation Date",
  "order.action": "Action",
  "order.handoverPerson": "Handover",
  "order.successor": "Successor",
  "order.operationBatchNumber": "Op Batch No.",
  "order.operator": "Operator",
  "order.projectManagerHandover": "PM Handover",
  "order.handlerHandover": "Handler Handover",
  "order.contractOwnerHandover": "Contract Owner Handover",
  "order.selectHandoverAction": "Select handover action",
  "order.selectHandoverPerson": "Select handover person",
  "order.selectSuccessor": "Select successor",
  "order.transferred": "Please check the order to be transferred first",
  "order.list.Time": "Time",
  "order.list.Task": "Task",
  "order.list.Time2": "Please select time",
  "order.list.Confirm": "Confirm",
  "order.list.Add": "Add",
  "order.list.change": "Change",
  "order.list.noorderchange": "Orders not assigned via contract cannot be changed",
  "order.list.currenttask": "The current task has not set up handling service and cannot be used as a precondition",
  "order.list.modified": "The completed task cannot be modified",
  "order.list.modified2": "The terminated task cannot be modified",
  "order.list.processTask": "Please process the {taskName} task on DingTalk",
  "order.list.Requiredinformation": "Required Documents",
  "order.list.Processingdocuments": "Processing Documents",
  "order.list.Deliverdocuments": "Deliver Documents",
  "order.list.Trash": "Trash",
  "order.list.Viewinstructions": " View Instructions",
  "order.list.Uploader": "Uploader",
  "order.list.Uploadtime": "Upload Time",
  "order.list.Upload": "Upload",
  "order.list.Listofdocuments": "List of Documents",
  "order.list.Adddata": "Add Data",
  "order.list.Dataname": "Data Name",
  "order.list.Pleaseselectdata": "Please select data",
  "order.list.Pleaseselectdataname": "Please select data name",
  "order.list.Content": "Content",
  "order.list.Pleaseentercontent": "Please enter content",
  "order.list.wanttorestore": "Are you sure you want to restore?",
  "order.list.wanttorestore.all": "Are you sure you want to restore all?",
  "order.list.Restore": "Restore",
  "order.list.Title": "Title",
  "order.list.retishi": "Are you sure you want to use the new data configuration? Confirming will clear the recycle bin records!",
  "order.list.Description": "File Description",
  "order.list.Fillperson": "Filled Person",
  "order.list.Filltime": "Filled Time",
  "order.list.heretoupload": "Click or drag files here to upload",
  "order.list.fileFormat": "File format",
  "order.list.DataManagement": "Data Management",
  "order.list.configuration": "Please delete all data before using the reset button to obtain the latest data configuration.",
  "order.list.notsupportenteringthedata": "This task type currently does not support entering the data management module.",
  "order.list.suspendtype": "SuspendType",
  "order.list.selectSuspendtype": "Please select suspend type",
  "order.list.attachment": "Kick-off Materials",
  'order.list.retract': 'Collapse',
  "order.list.expand": 'Expand',
  "order.list.contractchanged": 'The contract grade has been changed, and it will revert to unchecked status for rechecking the orders.',
  "order.list.hint": 'Hint',
  "order.list.BeijingTime": 'Beijing Time',
  "order.list.possible": 'Please arrange for sales to contact the customer as soon as possible',
  "order.list.lb": 'Only Interna',
  "order.list.khkj": 'Customer Visible',
  "order.list.projectkickoffmeetingdocument": 'Please upload the project kickoff meeting document.',
  "order.list.Negotiable": 'Negotiable',
  "order.list.ServiceTerminationNotice": 'Service Cancellation Note',
  "order.list.ApprovalNumber": 'Approval Number',
  "order.list.AcceptanceCondition": 'Acceptance Condition',
  "order.list.DingTalkapprovalnumber": 'Please enter DingTalk approval number for  Contract Change approval',
  "order.list.Filteritem": 'Filter Item',
  "order.list.Columnpresentation": 'Column Presentation',
  "order.list.Originaldate": 'Original Date',
  "order.list.Displaycolumn": 'Display Column',
  "order.list.Changedate": 'Change Date',
  "order.list.estimatedCompletionDate2": 'Request to modify the estimated completion date',
  "order.list.Modificationrecord": 'Modification Record',
  "order.list.back": 'Back',
  "order.list.Applicationdate": 'Application Date',
  "order.list.DingTalkprocessnumber": 'DingTalk Process Number',
  "order.list.searchforservices": 'Please enter keywords to search for services',
  "order.list.etc": 'ECD',
  "order.list.etcSub": 'Estimated Completion Date',
  "order.list.selectchangedate": 'Please select change date',
  "order.list.onetask": 'Please select at least one task',
  "order.list.ChineseSupport": 'CN Support',
  "order.list.aftersum": 'After submission, please supplement the application materials in DingTalk and submit the order process application!',
  "order.list.OverdueOrder": 'Overdue Order',
  "order.list.RiskOrder": 'Risk Order',
  "order.list.RiskService": 'Risk Service',
  "order.list.OverdueService": 'Overdue Service',
  "order.list.node.complete": 'Node Complete',
  "order.list.continue.process": 'Continue Process',
  "order.list.all.complete": 'Service Complete',
  "order.list.recall": 'Revoke',
  "order.list.pleaseContact": 'Please contact {name} for return',
  "order.list.systemcheck": 'System Check',
  "order.list.similarnonreasonable": 'has concurrent startup instances, potentially inappropriate',
  "order.list.receipttask": 'Payment Collection Task',
  "order.list.continueSubmit": 'Continue Submit',
  "order.list.backEdit": 'Back Edit',
  "order.list.month": 'Month',
  "order.list.quarter": 'Quarter',
  "order.list.Year": 'Year',
  "order.list.modifyEtc": 'Modify Estimated Completion Date',
  "order.list.customerVisible": 'Customer Visible',
  "order.list.customerVisibleOpen": 'On',
  "order.list.customerVisibleClose": 'Off',
  "order.list.departmentId": 'Department',
  "order.list.timelyAllocationOrder": 'Untimely Assigned Order',
  "order.list.nodeHandler": 'Node Handler',
  "order.list.copyContent": 'Copy Content',
  "order.list.serviceNum": 'Service Quantity',
  "order.list.copyNum": 'Copy Count',
  "order.copy.maxTip": "Maximum copies",
  "order.copy.unit": "",
  "order.copy.remainingTotal": "Total Remaining Services",
  "order.list.orderAllocation": 'Assign Status',
  "order.copy.noRemainingService": "This product has no remaining services",
  "order.list.unreasonable": 'Untimely',
  "order.list.attachment2": 'Attachment',
  "order.list.Pleaseuploadattachment": 'Please upload attachment',
  "order.list.day": 'Day',
  "order.list.month2": 'Month',
  "order.list.suspendReminder": 'Suspend Reminder',
  "order.list.nodeSuspend": 'Node Suspend {SuspendDay} days',
  "order.list.timelyAllocationOrder2": 'Untimely Assignment',
  "order.list.suspendTimeLimit": 'Suspend  reminder time cannot be empty',
  "order.list.viewAttachment": 'View Attachment',
  "order.list.expectedRestartTime": 'Expected restart time cannot be less than the current time',
  "order.list.allTaskCompleted": 'All services of the contract  completed',
  "order.list.editTask": 'Edit Task',
  "order.list.taskNameCNRequired": 'Task name (Chinese) cannot be empty',
  "order.list.checkDetails": 'Secondary Check Information',
  "order.list.allServiceCompleted": 'All services of the contract completed, then start the payment',
  "order.aiTask.title": "Task",
  "order.aiTask.result": "Result",
  "order.aiTask.aiRecognize": "AI Identify",
  "order.aiTask.reRecognize": "RE Identify",
  "order.aiTask.errorRetry": "Retry",
  "order.aiTask.confirm": "Confirm",
  "order.aiTask.completed": "Completed",
  "order.aiTask.uncompleted": "Uncompleted",
  "order.aiTask.pendingConfirmation": "To be confirmed",
  "order.aiTask.lastProcessTime": "Last Process Time",
  "order.aiTask.aiRecognizeError": "AI Identify Error, please try again later",
  "order.aiTask.aiRecognizeTimeout": "AI Analysis Timeout, please try again later",
  "order.aiTask.tips": "Tips",
  "order.aiTask.confirmContent": "Please confirm the data is correct?",
  "order.aiTask.loading": "The AI task is loading. Please try again later.",
  "order.aiTask.required": "Please complete the task：",
  "order.aiTask.multipleFiles": "Multiple files identified",
  "order.aiTask.noFile": "No file identified",
  "order.list.editEtc": "Edit Estimated Completion Date",
  "order.list.inAdvanceFinish": "Completed Early",
  "order.aiTask.notRecognize": "Some data was not identified. Please confirm manually.",
  "order.aiTask.confirmTip": "The following is the AI recognition content, please confirm, if there is no problem, please click to confirm that it is correct",
  "order.list.tips3": "Please enter the order number",
  "order.list.tips4": "The order number does not match the selected order",
  "order.list.tips5": "After the order is voided, all services under the order will be voided. Please proceed with caution.",
  "order.list.tips6": "After the order is closed, all unfinished services under the order will be stopped. Please proceed with caution.",
  "order.list.tips7": "After the order is reassigned, all services under the order will be voided. Please proceed with caution.",
  "order.aiTask.cancel": "Cancel",
  "order.aiTask.save": "Save",
  "order.aiTask.manualModify": "Manual Modify",
  "order.aiTask.confirmDiscard": "Are you sure to discard?",
  "order.aiTask.discard": "Discard",
  "order.aiTask.handler": "Handler",

  "order.list.copyCustomerData": "Copy Customer Documents",
  "order.list.customerData": "Customer Documents",
  "order.list.currentContract": "Current Contract",
  "order.list.otherContract": "Other Contract",
  "order.list.service": "Service",
  "order.list.service.placeholder": "Please enter the service name or number",
  "order.list.serviceRemark": "Service Remark",
  "order.list.confirmCopy": "Confirm Copy",
  "order.list.confirmCopyTip": "Are you sure to copy?",
  "order.list.copySuccess": "File Copy Success!",
  "order.list.copyFailed": "File Copy Failed!",
  "order.list.copyComplete": "Exit Copy",
  "order.list.continueCopy": "Continue Copy",
  "order.list.estimatedCompletionDate.new": "Estimated Completion Date",
  "order.list.systemFixAPrice": "System Fix Price",
  "order.list.receiptDataError": "Collection data error, please fill in timely",
  "order.list.isReassign": "Reassign Order",
  "order.list.reassignOrder": "Reassign Order",
  "order.list.tips8": "Please select whether to reassign the order",
  "order.list.yes": "Yes",
  "order.list.no": "No",
  "order.list.isNotifierWorkload": "Performance Ratio",
  "order.list.isNotifierWorkload2": "Per-Ratio",
  "order.list.isNotifierWorkload.yes": "Set",
  "order.list.isNotifierWorkload.no": "Unset",
  "order.list.setRatio": "Set Performance",
  "order.list.performanceRatio2": "Performance Ratio Setting",
  "order.list.setPerformanceRatio": "Set Performance",
  "order.list.projectStartUpConfigTip": "Kick-off Materials Not Uploaded",
  "order.list.performanceRatioTip": "Performance Ratio Not Fully Configured",
  "order.list.confirmSubmit": "Are you sure to continue submitting?",


  "payment.plan": "Repayment Plan",
  "payment.currentProgress": "Current Progress",
  "payment.plannedAmount": "Planned Amount",
  "payment.receivedAmount": "Received Amount",
  "payment.notStarted": "Not Started",
  "payment.inCollection": "In Collection",
  "payment.completed": "Completed",
  "payment.cancelled": "Cancelled",
  "payment.indication": "Indication",
  "order.list.set": "Set Performance",
  "order.list.howToSetMultiple": "How to set multiple?",
  "order.list.approved": "DingTalk Process Approvali",
}